import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  es: {
    // Navbar
    nav_products: "Productos",
    nav_services: "Servicios",
    nav_sectors: "Sectores",
    nav_pricing: "Precios",
    nav_testimonials: "Testimonios",
    nav_blog: "Blog",
    nav_contact: "Contacto",
    nav_plans: "Ver Planes",

    // Hero
    hero_powered: "Powered by",
    hero_experience: "+20 Años de Experiencia",
    hero_title_1: "Sistemas Operativos",
    hero_title_2: "Integrales",
    hero_title_3: "para el Futuro",
    hero_subtitle: "Desarrollamos soluciones tecnologicas personalizadas que transforman la manera en que las empresas operan. Seguridad, velocidad y control total.",
    hero_cta_plans: "Ver Planes",
    hero_cta_demo: "Solicitar Demo",
    hero_pill_1: "Seguridad Avanzada",
    hero_pill_2: "Rendimiento Optimizado",
    hero_pill_3: "Acceso Global",
    hero_explore: "Explorar",

    // Products
    products_badge: "Ecosistema de Productos",
    products_title_1: "Nuestros",
    products_title_2: "Sistemas",
    products_subtitle: "Soluciones empresariales desarrolladas por Global Metafora APP para impulsar cada area de tu negocio",
    products_free_trial: "Prueba gratuita 15 dias en todos los sistemas",
    products_try_free: "Probar Gratis 15 Dias",
    products_coming_soon: "Disponible Pronto",
    products_view_production: "Ver sistema en produccion",
    products_view_all_demos: "Ver Todas las Demos Disponibles",
    products_demo_active: "Demo Activo",
    products_soon: "Pronto",
    products_tech_note: "Todos los sistemas desarrollados con tecnologia",

    // Version Cloud/Local
    version_cloud: "Version Cloud",
    version_local: "Version Local",
    version_cloud_desc: "(suscripcion mensual) — con WhatsApp, dominio, rastreo publico",
    version_local_desc: "(pago unico) — instalado en su PC, sin costos recurrentes",

    // Version Comparison
    comparison_badge: "Modalidades",
    comparison_title_1: "Cloud vs",
    comparison_title_2: "Local",
    comparison_subtitle: "Elige la version que mejor se adapte a tu negocio. Ambas con la misma potencia de Global Metafora APP.",
    comparison_compare: "Comparar",
    comparison_cloud_sub: "Suscripcion mensual — Todo en la nube",
    comparison_local_sub: "Pago unico — Instalado en su PC",
    comparison_cta_text: "No sabes cual elegir? Contactanos y te asesoramos sin compromiso.",
    comparison_cta_btn: "Solicitar Asesoria Gratuita",

    // Comparison features
    feat_access: "Acceso al sistema",
    feat_access_cloud: "Desde cualquier navegador, movil o PC",
    feat_access_local: "Solo desde la computadora instalada",
    feat_whatsapp: "WhatsApp integrado",
    feat_whatsapp_cloud: "Notificaciones y mensajes directos a clientes",
    feat_whatsapp_local: "No incluido",
    feat_domain: "Dominio personalizado",
    feat_domain_cloud: "tunegocio.globalmetafora.com incluido",
    feat_domain_local: "No aplica",
    feat_tracking: "Rastreo publico de clientes",
    feat_tracking_cloud: "Tus clientes rastrean pedidos online",
    feat_tracking_local: "Solo acceso interno",
    feat_payment: "Modelo de pago",
    feat_payment_cloud: "Suscripcion mensual accesible",
    feat_payment_local: "Pago unico, tuyo para siempre",
    feat_recurring: "Costos recurrentes",
    feat_recurring_cloud: "Incluye hosting, soporte y actualizaciones",
    feat_recurring_local: "Sin costos recurrentes",
    feat_updates: "Actualizaciones",
    feat_updates_cloud: "Automaticas, siempre la ultima version",
    feat_updates_local: "Manuales, a su ritmo",
    feat_storage: "Almacenamiento de datos",
    feat_storage_cloud: "Nube segura con respaldos automaticos",
    feat_storage_local: "En su computadora, usted controla",
    feat_support: "Soporte tecnico",
    feat_support_cloud: "Incluido, prioritario 24/7",
    feat_support_local: "Disponible como servicio adicional",
    feat_install: "Instalacion",
    feat_install_cloud: "Inmediata, sin configuracion",
    feat_install_local: "Instalamos en su PC sin costo extra",

    // Quiz
    quiz_title: "Cual version me conviene?",
    quiz_subtitle: "Responde 4 preguntas rapidas y te recomendaremos la mejor opcion para tu negocio.",
    quiz_start: "Comenzar",
    quiz_time: "Solo toma 30 segundos",
    quiz_back: "Atras",
    quiz_recommend: "Te recomendamos",
    quiz_more_info: "Quiero mas informacion",
    quiz_restart: "Repetir quiz",
    quiz_form_title: "Recibe asesoria personalizada",
    quiz_form_subtitle: "Dejanos tus datos y un asesor te contactara con la mejor propuesta.",
    quiz_submit: "Enviar solicitud",
    quiz_success_title: "Solicitud enviada",
    quiz_success_msg: "Un asesor de Global Metafora APP te contactara pronto con la mejor propuesta para tu negocio.",
    quiz_redo: "Hacer el quiz de nuevo",
    quiz_back_result: "Volver al resultado",
    quiz_q1: "Donde necesitas acceder al sistema?",
    quiz_q1_a: "Desde cualquier lugar",
    quiz_q1_a_desc: "Movil, tablet, otra PC, viajando",
    quiz_q1_b: "Solo desde mi oficina",
    quiz_q1_b_desc: "Una computadora fija en mi negocio",
    quiz_q2: "Necesitas comunicarte con clientes por WhatsApp?",
    quiz_q2_a: "Si, es importante",
    quiz_q2_a_desc: "Notificaciones, estados y mensajes directos",
    quiz_q2_b: "No lo necesito",
    quiz_q2_b_desc: "Manejo comunicacion por otros medios",
    quiz_q3: "Como prefieres pagar?",
    quiz_q3_a: "Suscripcion mensual",
    quiz_q3_a_desc: "Pago accesible mes a mes, todo incluido",
    quiz_q3_b: "Pago unico",
    quiz_q3_b_desc: "Una sola inversion, sin costos recurrentes",
    quiz_q4: "Tus clientes necesitan rastrear pedidos online?",
    quiz_q4_a: "Si, con pagina publica",
    quiz_q4_a_desc: "Mis clientes rastrean desde su celular",
    quiz_q4_b: "No, es uso interno",
    quiz_q4_b_desc: "Solo mi equipo usa el sistema",
    quiz_result_cloud_title: "Version Cloud",
    quiz_result_cloud_sub: "Suscripcion mensual — Todo en la nube",
    quiz_result_local_title: "Version Local",
    quiz_result_local_sub: "Pago unico — Instalado en su PC",
    quiz_result_both_title: "Ambas versiones te convienen",
    quiz_result_both_sub: "Contactanos para asesorarte mejor",

    // Services
    services_label: "Lo Que Ofrecemos",
    services_title: "Soluciones Integrales",
    services_subtitle: "No vendemos simplemente software. Entregamos soluciones completas que transforman la manera en que las empresas operan.",

    // Sectors
    sectors_label: "Experiencia Multisectorial",
    sectors_title: "Sectores que Transformamos",
    sectors_subtitle: "Desarrollamos soluciones especializadas para cada industria, adaptandonos a las necesidades unicas de cada sector.",

    // Pricing
    pricing_badge: "Soluciones",
    pricing_title: "Elige tu Nivel",
    pricing_subtitle: "Planes flexibles disenados para crecer con tu negocio. Sin sorpresas, sin costos ocultos.",
    pricing_cta: "Solicitar Informacion",
    pricing_all_include: "Todos los planes incluyen soporte de",
    pricing_different: "Necesitas algo diferente? Hablemos",
    pricing_popular: "Mas Popular",

    // Testimonials
    testimonials_label: "Testimonios",
    testimonials_title: "Lo que Dicen Nuestros Clientes",
    testimonials_subtitle: "Empresas de todos los sectores confian en nosotros para impulsar su transformacion digital.",
    testimonials_brand: "Clientes de Global Metafora APP",

    // FAQ
    faq_label: "Preguntas Frecuentes",
    faq_title: "Tienes Dudas?",
    faq_subtitle: "Aqui encontraras respuestas a las preguntas mas comunes.",
    faq_need_help: "Necesitas mas ayuda?",
    faq_contact_team: "Contacta con nuestro equipo",
    faq_satisfaction: "Satisfaccion",
    faq_support: "Soporte",
    faq_response: "Respuesta",

    // Contact
    contact_label: "Contacto",
    contact_title: "Hablemos de tu Proyecto",
    contact_subtitle: "Estamos listos para ayudarte a transformar tu negocio.",
    contact_phone_label: "Telefono",
    contact_address_label: "Direccion",
    contact_website_label: "Website",
    contact_form_title: "Envianos un Mensaje",
    contact_form_subtitle: "Respuesta en menos de 24 horas",
    contact_name: "Nombre *",
    contact_name_ph: "Tu nombre",
    contact_email: "Email *",
    contact_email_ph: "tu@email.com",
    contact_company: "Empresa",
    contact_company_ph: "Nombre de tu empresa",
    contact_phone: "Telefono",
    contact_phone_ph: "+1 (555) 000-0000",
    contact_message: "Mensaje *",
    contact_message_ph: "Cuentanos sobre tu proyecto...",
    contact_send: "Enviar Mensaje",
    contact_sending: "Enviando...",
    contact_sent: "Enviado!",
    contact_success: "Mensaje enviado! Nos pondremos en contacto contigo pronto.",
    contact_error: "Error al enviar el mensaje. Por favor intenta nuevamente.",
    contact_confidential: "Maxima Confidencialidad Garantizada",
    contact_confidential_desc: "Toda la informacion compartida esta protegida bajo estrictos acuerdos de confidencialidad.",

    // Footer
    footer_quick_links: "Enlaces Rapidos",
    footer_contact: "Contacto",
    footer_rights: "Todos los derechos reservados.",
    footer_director: "Director General",
    footer_privacy: "Politica de Privacidad",
    footer_terms: "Terminos de Servicio",

    // Demos page
    demos_free_badge: "15 Dias Gratis · Sin Tarjeta de Credito",
    demos_title_1: "Prueba Nuestros",
    demos_title_2: "Sistemas",
    demos_title_3: "Gratis",
    demos_subtitle: "Accede a demos completos de cada sistema por 15 dias. Explora todas las funcionalidades sin compromiso.",
    demos_active: "demos activos",
    demos_coming: "proximamente",
    demos_available: "Demo Disponible",
    demos_not_found: "No encuentras lo que buscas?",
    demos_custom: "Desarrollamos soluciones a medida para tu empresa. Contactanos para una consulta personalizada.",
    demos_contact_btn: "Contactar a Global Metafora APP",
    demos_back: "Volver al inicio",
    demos_try_free: "Probar Gratis 15 Dias",
    demos_coming_soon: "Proximamente",

    // Director
    director_label: "Liderazgo",
    director_role: "Ingeniero en Sistemas Operativos / Director General",

    // e-CF Section
    ecf_badge: "Facturacion Electronica",
    ecf_title_1: "Facturacion",
    ecf_title_2: "Electronica (e-CF)",
    ecf_subtitle: "Cumple con la Ley 32-23 de la DGII. Te ayudamos a implementar la facturacion electronica obligatoria para tu negocio en Republica Dominicana.",
    ecf_alert_title: "Obligatorio por Ley 32-23",
    ecf_alert_desc: "La DGII exige que todos los contribuyentes emitan comprobantes fiscales electronicos (e-CF). Las fechas limite ya estan vigentes. Incumplir implica sanciones fiscales.",
    ecf_tab_why: "Por que e-CF?",
    ecf_tab_deadlines: "Fechas Limite",
    ecf_tab_how: "Como Funciona",
    ecf_benefit_1_title: "Cumplimiento Legal",
    ecf_benefit_1_desc: "Evita sanciones fiscales cumpliendo con la Ley 32-23 y el Decreto 587-24 de la DGII.",
    ecf_benefit_2_title: "Automatizacion Total",
    ecf_benefit_2_desc: "Genera, firma y envia facturas a la DGII automaticamente desde nuestro sistema.",
    ecf_benefit_3_title: "Acceso Universal",
    ecf_benefit_3_desc: "Factura desde cualquier lugar. Tus comprobantes disponibles 24/7 con almacenamiento por 10 anos.",
    ecf_benefit_4_title: "Firma Digital",
    ecf_benefit_4_desc: "XML firmado digitalmente con certificado X.509 conforme a los estandares de la DGII.",
    ecf_step_1_title: "Verifica tu RNC",
    ecf_step_1_desc: "Asegurate de que tu RNC este activo y al dia ante la DGII. Este es el primer requisito.",
    ecf_step_2_title: "Obtener Certificado Digital",
    ecf_step_2_desc: "Solicita tu certificado digital en CAMARDOM u otra entidad autorizada por INDOTEL (~$50-100 USD/ano).",
    ecf_step_3_title: "Autorizacion DGII",
    ecf_step_3_desc: "Completa el formulario FI-GDF-016 en la Oficina Virtual de DGII para solicitar la autorizacion de e-CF.",
    ecf_step_4_title: "Pruebas y Produccion",
    ecf_step_4_desc: "Nuestro sistema automatiza las pruebas con DGII. Una vez aprobadas, comienzas a facturar en produccion.",
    ecf_deadline_big: "Grandes contribuyentes nacionales",
    ecf_deadline_big_date: "Ya obligatorio",
    ecf_deadline_medium: "Grandes contribuyentes locales y medianos",
    ecf_deadline_small: "Micro, pequenas empresas y no clasificados",
    ecf_deadline_note: "Fuente: DGII - Ley 32-23 y Decreto 587-24. Incumplimiento conlleva sanciones fiscales.",
    ecf_cta_contact: "Solicitar Asesoria e-CF",
    ecf_cta_portal: "Acceder al Portal",
    ecf_cta_note: "Te orientamos en todo el proceso. Sin compromiso.",

    // e-CF Packages
    ecf_tab_packages: "Paquetes",
    ecf_compatible_with: "Compatible con todos nuestros sistemas",
    ecf_sys_accounting: "Sistema de Contabilidad",
    ecf_sys_accounting_desc: "Facturacion electronica integrada",
    ecf_sys_pos: "Sistema POS (Punto de Venta)",
    ecf_sys_pos_desc: "Emite e-CF desde tu punto de venta",
    ecf_sys_inventory: "Sistema de Inventario",
    ecf_sys_inventory_desc: "Facturas vinculadas a tu inventario",
    ecf_pkg_basic_name: "Paquete Basico",
    ecf_pkg_basic_desc: "Orientacion y soporte para que empieces rapido",
    ecf_pkg_basic_f1: "Orientacion completa paso a paso",
    ecf_pkg_basic_f2: "Checklist de requisitos DGII",
    ecf_pkg_basic_f3: "Soporte por WhatsApp (30 dias)",
    ecf_pkg_basic_f4: "Configuracion inicial del sistema",
    ecf_pkg_complete_name: "Paquete Completo",
    ecf_pkg_complete_desc: "Nosotros hacemos todo por ti",
    ecf_pkg_complete_f1: "Todo lo del Paquete Basico",
    ecf_pkg_complete_f2: "Gestion del certificado digital (CAMARDOM)",
    ecf_pkg_complete_f3: "Tramite de autorizacion DGII (FI-GDF-016)",
    ecf_pkg_complete_f4: "Configuracion completa del sistema",
    ecf_pkg_complete_f5: "Pruebas de certificacion con DGII",
    ecf_pkg_complete_f6: "Capacitacion virtual (2 horas)",
    ecf_pkg_premium_name: "Paquete Premium",
    ecf_pkg_premium_desc: "Servicio VIP con soporte extendido",
    ecf_pkg_premium_f1: "Todo lo del Paquete Completo",
    ecf_pkg_premium_f2: "Capacitacion presencial en tu oficina",
    ecf_pkg_premium_f3: "Soporte prioritario (3 meses)",
    ecf_pkg_premium_f4: "Migracion de facturas existentes",
    ecf_pkg_premium_f5: "Configuracion de multiples sucursales",
    ecf_pkg_premium_f6: "Reportes fiscales personalizados",
    ecf_pkg_premium_f7: "Actualizaciones regulatorias incluidas (1 ano)",
    ecf_pkg_popular: "Mas popular",
    ecf_pkg_cta: "Solicitar Paquete",
    ecf_pkg_monthly_note: "Ademas, servicio mensual de facturacion electronica desde",
    ecf_pkg_monthly_price: "RD$ 1,500/mes por empresa",
    ecf_form_title: "Solicitar Paquete e-CF",
    ecf_form_subtitle: "Te contactaremos en menos de 24 horas",
    ecf_form_name: "Tu nombre completo",
    ecf_form_email: "Tu correo electronico",
    ecf_form_phone: "Telefono (opcional)",
    ecf_form_company: "Nombre de tu empresa (opcional)",
    ecf_form_send: "Enviar Solicitud",
    ecf_form_success_title: "Solicitud Enviada",
    ecf_form_success_msg: "Nos comunicaremos contigo en las proximas 24 horas para orientarte.",
    ecf_form_close: "Cerrar",
  },
  en: {
    // Navbar
    nav_products: "Products",
    nav_services: "Services",
    nav_sectors: "Sectors",
    nav_pricing: "Pricing",
    nav_testimonials: "Testimonials",
    nav_blog: "Blog",
    nav_contact: "Contact",
    nav_plans: "View Plans",

    // Hero
    hero_powered: "Powered by",
    hero_experience: "+20 Years of Experience",
    hero_title_1: "Integral Operating",
    hero_title_2: "Systems",
    hero_title_3: "for the Future",
    hero_subtitle: "We develop customized technological solutions that transform the way businesses operate. Security, speed, and total control.",
    hero_cta_plans: "View Plans",
    hero_cta_demo: "Request Demo",
    hero_pill_1: "Advanced Security",
    hero_pill_2: "Optimized Performance",
    hero_pill_3: "Global Access",
    hero_explore: "Explore",

    // Products
    products_badge: "Product Ecosystem",
    products_title_1: "Our",
    products_title_2: "Systems",
    products_subtitle: "Enterprise solutions developed by Global Metafora APP to boost every area of your business",
    products_free_trial: "Free 15-day trial on all systems",
    products_try_free: "Try Free 15 Days",
    products_coming_soon: "Coming Soon",
    products_view_production: "View production system",
    products_view_all_demos: "View All Available Demos",
    products_demo_active: "Demo Active",
    products_soon: "Soon",
    products_tech_note: "All systems developed with",

    // Version Cloud/Local
    version_cloud: "Cloud Version",
    version_local: "Local Version",
    version_cloud_desc: "(monthly subscription) — with WhatsApp, domain, public tracking",
    version_local_desc: "(one-time payment) — installed on your PC, no recurring costs",

    // Version Comparison
    comparison_badge: "Modalities",
    comparison_title_1: "Cloud vs",
    comparison_title_2: "Local",
    comparison_subtitle: "Choose the version that best fits your business. Both with the full power of Global Metafora APP.",
    comparison_compare: "Compare",
    comparison_cloud_sub: "Monthly subscription — Everything in the cloud",
    comparison_local_sub: "One-time payment — Installed on your PC",
    comparison_cta_text: "Not sure which to choose? Contact us for free guidance.",
    comparison_cta_btn: "Request Free Consultation",

    // Comparison features
    feat_access: "System access",
    feat_access_cloud: "From any browser, mobile or PC",
    feat_access_local: "Only from the installed computer",
    feat_whatsapp: "WhatsApp integrated",
    feat_whatsapp_cloud: "Notifications and direct messages to clients",
    feat_whatsapp_local: "Not included",
    feat_domain: "Custom domain",
    feat_domain_cloud: "yourbusiness.globalmetafora.com included",
    feat_domain_local: "Not applicable",
    feat_tracking: "Public client tracking",
    feat_tracking_cloud: "Your clients track orders online",
    feat_tracking_local: "Internal access only",
    feat_payment: "Payment model",
    feat_payment_cloud: "Affordable monthly subscription",
    feat_payment_local: "One-time payment, yours forever",
    feat_recurring: "Recurring costs",
    feat_recurring_cloud: "Includes hosting, support and updates",
    feat_recurring_local: "No recurring costs",
    feat_updates: "Updates",
    feat_updates_cloud: "Automatic, always the latest version",
    feat_updates_local: "Manual, at your own pace",
    feat_storage: "Data storage",
    feat_storage_cloud: "Secure cloud with automatic backups",
    feat_storage_local: "On your computer, you control it",
    feat_support: "Technical support",
    feat_support_cloud: "Included, 24/7 priority",
    feat_support_local: "Available as additional service",
    feat_install: "Installation",
    feat_install_cloud: "Instant, no configuration needed",
    feat_install_local: "We install on your PC at no extra cost",

    // Quiz
    quiz_title: "Which version suits me?",
    quiz_subtitle: "Answer 4 quick questions and we'll recommend the best option for your business.",
    quiz_start: "Start",
    quiz_time: "Only takes 30 seconds",
    quiz_back: "Back",
    quiz_recommend: "We recommend",
    quiz_more_info: "I want more information",
    quiz_restart: "Retake quiz",
    quiz_form_title: "Get personalized advice",
    quiz_form_subtitle: "Leave your details and an advisor will contact you with the best proposal.",
    quiz_submit: "Submit request",
    quiz_success_title: "Request sent",
    quiz_success_msg: "A Global Metafora APP advisor will contact you soon with the best proposal for your business.",
    quiz_redo: "Take the quiz again",
    quiz_back_result: "Back to result",
    quiz_q1: "Where do you need to access the system?",
    quiz_q1_a: "From anywhere",
    quiz_q1_a_desc: "Mobile, tablet, another PC, traveling",
    quiz_q1_b: "Only from my office",
    quiz_q1_b_desc: "A fixed computer in my business",
    quiz_q2: "Do you need to communicate with clients via WhatsApp?",
    quiz_q2_a: "Yes, it's important",
    quiz_q2_a_desc: "Notifications, statuses and direct messages",
    quiz_q2_b: "I don't need it",
    quiz_q2_b_desc: "I handle communication through other channels",
    quiz_q3: "How do you prefer to pay?",
    quiz_q3_a: "Monthly subscription",
    quiz_q3_a_desc: "Affordable monthly payment, all included",
    quiz_q3_b: "One-time payment",
    quiz_q3_b_desc: "A single investment, no recurring costs",
    quiz_q4: "Do your clients need to track orders online?",
    quiz_q4_a: "Yes, with a public page",
    quiz_q4_a_desc: "My clients track from their phone",
    quiz_q4_b: "No, it's for internal use",
    quiz_q4_b_desc: "Only my team uses the system",
    quiz_result_cloud_title: "Cloud Version",
    quiz_result_cloud_sub: "Monthly subscription — Everything in the cloud",
    quiz_result_local_title: "Local Version",
    quiz_result_local_sub: "One-time payment — Installed on your PC",
    quiz_result_both_title: "Both versions suit you",
    quiz_result_both_sub: "Contact us for better guidance",

    // Services
    services_label: "What We Offer",
    services_title: "Comprehensive Solutions",
    services_subtitle: "We don't just sell software. We deliver complete solutions that transform the way businesses operate.",

    // Sectors
    sectors_label: "Multi-sector Experience",
    sectors_title: "Sectors We Transform",
    sectors_subtitle: "We develop specialized solutions for each industry, adapting to the unique needs of each sector.",

    // Pricing
    pricing_badge: "Solutions",
    pricing_title: "Choose your Level",
    pricing_subtitle: "Flexible plans designed to grow with your business. No surprises, no hidden costs.",
    pricing_cta: "Request Information",
    pricing_all_include: "All plans include support from",
    pricing_different: "Need something different? Let's talk",
    pricing_popular: "Most Popular",

    // Testimonials
    testimonials_label: "Testimonials",
    testimonials_title: "What Our Clients Say",
    testimonials_subtitle: "Companies from all sectors trust us to drive their digital transformation.",
    testimonials_brand: "Global Metafora APP Clients",

    // FAQ
    faq_label: "FAQ",
    faq_title: "Have Questions?",
    faq_subtitle: "Here you'll find answers to the most common questions.",
    faq_need_help: "Need more help?",
    faq_contact_team: "Contact our team",
    faq_satisfaction: "Satisfaction",
    faq_support: "Support",
    faq_response: "Response",

    // Contact
    contact_label: "Contact",
    contact_title: "Let's Talk About Your Project",
    contact_subtitle: "We're ready to help you transform your business.",
    contact_phone_label: "Phone",
    contact_address_label: "Address",
    contact_website_label: "Website",
    contact_form_title: "Send Us a Message",
    contact_form_subtitle: "Response in less than 24 hours",
    contact_name: "Name *",
    contact_name_ph: "Your name",
    contact_email: "Email *",
    contact_email_ph: "your@email.com",
    contact_company: "Company",
    contact_company_ph: "Your company name",
    contact_phone: "Phone",
    contact_phone_ph: "+1 (555) 000-0000",
    contact_message: "Message *",
    contact_message_ph: "Tell us about your project...",
    contact_send: "Send Message",
    contact_sending: "Sending...",
    contact_sent: "Sent!",
    contact_success: "Message sent! We'll get in touch with you soon.",
    contact_error: "Error sending message. Please try again.",
    contact_confidential: "Maximum Confidentiality Guaranteed",
    contact_confidential_desc: "All shared information is protected under strict confidentiality agreements.",

    // Footer
    footer_quick_links: "Quick Links",
    footer_contact: "Contact",
    footer_rights: "All rights reserved.",
    footer_director: "CEO",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Service",

    // Demos page
    demos_free_badge: "15 Days Free · No Credit Card",
    demos_title_1: "Try Our",
    demos_title_2: "Systems",
    demos_title_3: "Free",
    demos_subtitle: "Access complete demos of each system for 15 days. Explore all features with no commitment.",
    demos_active: "active demos",
    demos_coming: "coming soon",
    demos_available: "Demo Available",
    demos_not_found: "Can't find what you're looking for?",
    demos_custom: "We develop custom solutions for your business. Contact us for a personalized consultation.",
    demos_contact_btn: "Contact Global Metafora APP",
    demos_back: "Back to home",
    demos_try_free: "Try Free 15 Days",
    demos_coming_soon: "Coming Soon",

    // Director
    director_label: "Leadership",
    director_role: "Operating Systems Engineer / CEO",

    // e-CF Section
    ecf_badge: "Electronic Invoicing",
    ecf_title_1: "Electronic",
    ecf_title_2: "Invoicing (e-CF)",
    ecf_subtitle: "Comply with DGII Law 32-23. We help you implement the mandatory electronic invoicing for your business in the Dominican Republic.",
    ecf_alert_title: "Required by Law 32-23",
    ecf_alert_desc: "The DGII requires all taxpayers to issue electronic fiscal receipts (e-CF). Deadlines are already in effect. Non-compliance implies tax penalties.",
    ecf_tab_why: "Why e-CF?",
    ecf_tab_deadlines: "Deadlines",
    ecf_tab_how: "How It Works",
    ecf_benefit_1_title: "Legal Compliance",
    ecf_benefit_1_desc: "Avoid tax penalties by complying with DGII Law 32-23 and Decree 587-24.",
    ecf_benefit_2_title: "Full Automation",
    ecf_benefit_2_desc: "Generate, sign and send invoices to DGII automatically from our system.",
    ecf_benefit_3_title: "Universal Access",
    ecf_benefit_3_desc: "Invoice from anywhere. Your receipts available 24/7 with 10-year storage.",
    ecf_benefit_4_title: "Digital Signature",
    ecf_benefit_4_desc: "XML digitally signed with X.509 certificate per DGII standards.",
    ecf_step_1_title: "Verify your RNC",
    ecf_step_1_desc: "Make sure your RNC is active and up to date with DGII. This is the first requirement.",
    ecf_step_2_title: "Get Digital Certificate",
    ecf_step_2_desc: "Request your digital certificate from CAMARDOM or another INDOTEL-authorized entity (~$50-100 USD/year).",
    ecf_step_3_title: "DGII Authorization",
    ecf_step_3_desc: "Complete form FI-GDF-016 on the DGII Virtual Office to request e-CF authorization.",
    ecf_step_4_title: "Testing & Production",
    ecf_step_4_desc: "Our system automates DGII testing. Once approved, you start invoicing in production.",
    ecf_deadline_big: "Large national taxpayers",
    ecf_deadline_big_date: "Already mandatory",
    ecf_deadline_medium: "Large local and medium taxpayers",
    ecf_deadline_small: "Micro, small businesses and unclassified",
    ecf_deadline_note: "Source: DGII - Law 32-23 and Decree 587-24. Non-compliance carries tax penalties.",
    ecf_cta_contact: "Request e-CF Advisory",
    ecf_cta_portal: "Access Portal",
    ecf_cta_note: "We guide you through the entire process. No commitment.",

    // e-CF Packages
    ecf_tab_packages: "Packages",
    ecf_compatible_with: "Compatible with all our systems",
    ecf_sys_accounting: "Accounting System",
    ecf_sys_accounting_desc: "Integrated electronic invoicing",
    ecf_sys_pos: "POS System (Point of Sale)",
    ecf_sys_pos_desc: "Issue e-CF from your point of sale",
    ecf_sys_inventory: "Inventory System",
    ecf_sys_inventory_desc: "Invoices linked to your inventory",
    ecf_pkg_basic_name: "Basic Package",
    ecf_pkg_basic_desc: "Guidance and support to get started quickly",
    ecf_pkg_basic_f1: "Complete step-by-step guidance",
    ecf_pkg_basic_f2: "DGII requirements checklist",
    ecf_pkg_basic_f3: "WhatsApp support (30 days)",
    ecf_pkg_basic_f4: "Initial system configuration",
    ecf_pkg_complete_name: "Complete Package",
    ecf_pkg_complete_desc: "We handle everything for you",
    ecf_pkg_complete_f1: "Everything in Basic Package",
    ecf_pkg_complete_f2: "Digital certificate management (CAMARDOM)",
    ecf_pkg_complete_f3: "DGII authorization process (FI-GDF-016)",
    ecf_pkg_complete_f4: "Full system configuration",
    ecf_pkg_complete_f5: "DGII certification testing",
    ecf_pkg_complete_f6: "Virtual training (2 hours)",
    ecf_pkg_premium_name: "Premium Package",
    ecf_pkg_premium_desc: "VIP service with extended support",
    ecf_pkg_premium_f1: "Everything in Complete Package",
    ecf_pkg_premium_f2: "On-site training at your office",
    ecf_pkg_premium_f3: "Priority support (3 months)",
    ecf_pkg_premium_f4: "Migration of existing invoices",
    ecf_pkg_premium_f5: "Multi-branch configuration",
    ecf_pkg_premium_f6: "Custom fiscal reports",
    ecf_pkg_premium_f7: "Regulatory updates included (1 year)",
    ecf_pkg_popular: "Most popular",
    ecf_pkg_cta: "Request Package",
    ecf_pkg_monthly_note: "Plus, monthly electronic invoicing service starting at",
    ecf_pkg_monthly_price: "RD$ 1,500/month per company",
    ecf_form_title: "Request e-CF Package",
    ecf_form_subtitle: "We'll contact you within 24 hours",
    ecf_form_name: "Your full name",
    ecf_form_email: "Your email",
    ecf_form_phone: "Phone (optional)",
    ecf_form_company: "Company name (optional)",
    ecf_form_send: "Send Request",
    ecf_form_success_title: "Request Sent",
    ecf_form_success_msg: "We will contact you within the next 24 hours to guide you.",
    ecf_form_close: "Close",
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("gm_lang") || "es");

  useEffect(() => {
    localStorage.setItem("gm_lang", lang);
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.es[key] || key;

  const toggleLang = () => setLang((prev) => (prev === "es" ? "en" : "es"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
};
